import { useMemo } from 'react'
import { Dropdown } from 'components/common'
import {
  FilterDateInput,
  FilterTextInput,
} from 'components/common/logFilterInputs'
import useLogFilters from 'hooks/useLogFilters'
import { buildEnumOptions, FilterMeta } from 'utils/helpers'

type Props = {
  filterMeta?: FilterMeta
}

export const FILTER_FIELD_RECONCILIATION_LOG = 'reconciliationLogFilters'

const ReconciliationLogFilterForm = ({ filterMeta }: Props) => {
  const { filters, setField } = useLogFilters(FILTER_FIELD_RECONCILIATION_LOG)

  const typeOptions = useMemo(
    () =>
      buildEnumOptions(filterMeta, 'type', ['ORDER', 'RMA', 'RMA ERP SYNC']),
    [filterMeta],
  )

  return (
    <div className="mb-6 flex flex-wrap items-end gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 shadow-sm">
      <div className="min-w-[200px]">
        <Dropdown
          name="type"
          label="Type"
          options={typeOptions}
          defaultValue={filters.type || ''}
          setValue={(_field: string, value: string) => setField('type', value)}
        />
      </div>

      <FilterTextInput
        label="Order No"
        value={filters.orderNo || ''}
        onApply={(value) => setField('orderNo', value)}
      />

      <FilterTextInput
        label="Status"
        value={filters.status || ''}
        onApply={(value) => setField('status', value)}
      />

      <FilterDateInput
        label="Start Date"
        value={filters.startDate || ''}
        onChange={(value) => setField('startDate', value)}
      />

      <FilterDateInput
        label="End Date"
        value={filters.endDate || ''}
        onChange={(value) => setField('endDate', value)}
      />
    </div>
  )
}

export default ReconciliationLogFilterForm
